<script>
import {execCommand} from "@/domain/gerencia/servidor/services"
import {addHours, format, subHours} from "date-fns"
import {logBuffer} from "@/domain/logs/service/log"

export default {
  name: "ClienteSetup",
  props: {
    cliente: {
      required: true
    }
  },
  data () {
    return {
      loading: false,
      started: false,
      buffer: []
    }
  },
  mounted() {
    this.$logBufferInterval = setInterval(this.loadLogs, 4000)
  },
  beforeDestroy() {
    this.$logBufferInterval && clearInterval(this.$logBufferInterval)
  },
  methods: {
    loadLogs() {
      let command = this.command
      // command = command.split(' ')
      // command = command[0]
      let date1 = format(subHours(new Date(), 1), 'yyyy-MM-dd HH:mm:ss')
      let date2 = format(addHours(new Date(), 1), 'yyyy-MM-dd HH:mm:ss')
      logBuffer('setup', 'setup-cli-' + this.cliente.id, '', date1, date2)
          .then(({data}) => {
            this.buffer = data
          })
          .catch(error => {
            console.log(error)
          })
    },
    parseMessage (m) {
      return m.replace(/\n/g, "<br>")
    },
    start () {
      this.loading = true
      this.started = true
      execCommand('cliente/instalar ' + this.cliente.id)
          .then(data => {
            console.log(data)
            this.loading = false
          })
          .catch(error => {
            this.alertApiError(error)
            this.loading = false
          })
    },
    startConfigure () {
      this.loading = true
      this.started = true
      execCommand('cliente/configurar ' + this.cliente.id)
          .then(data => {
            console.log(data)
            this.loading = false
          })
          .catch(error => {
            this.alertApiError(error)
            this.loading = false
          })
    }
  }
}
</script>

<template>
  <div class="cliente-setup">
    <u-btn class="sl-btn" color="black" label="Executar Setup do cliente" no-caps @click="start" :loading="loading" />
    <u-btn class="sl-btn m-l" color="blue" label="Executar Configuração do DB do cliente" no-caps @click="startConfigure" :loading="loading" />
    <div class="m-t-lg" v-if="started">
      <div class="erp-console-log erp-terminal full-width" ref="terminal">
        <vue-typed-js :typeSpeed="5" class="hideCursor"
                      :strings="['Executando atualização da instância ' + cliente.dominio + '...']">
          <div class="typing text-positive"></div>
        </vue-typed-js>
        <div v-for="message in buffer" :key="message.id" class="log log-buffer m-t-xs">
          [{{ message.date.date|formatDate }}] [{{message.person}}] [{{message.user}}] <span v-html="parseMessage(message.message)"></span>
        </div>
      </div>
    </div>
  </div>
</template>
